import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getNurseCallingRequests ({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/nursecallingrequests/_filter?pageSize=4&pageNumber=' + options.pageNumber, {
          nursegroup: options.nursegeoupId,
          latestStatus: ['Created', 'InProgress']
        })).data || null
      } catch (e) {
        console.log(e)
      }
    },
    async acceptNurseCallingRequest ({ state }, options) {
      let nurseCallingRequest = options.nurseCallingRequest
      nurseCallingRequest.attendant = options.userId
      nurseCallingRequest.status.push({
        status: 'InProgress',
        timestamp: new Date().getTime()
      })
      nurseCallingRequest.latestStatus = 'InProgress'
      try {
        return (await Vue.http.put(this.state.baseUrl + '/nursecallingrequests/' + nurseCallingRequest._id, nurseCallingRequest)).data || null
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async completeNurseCallingRequest ({ state }, nurseCallingRequestId) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/nursecallingrequests/' + nurseCallingRequestId + '/status', {
          status: 'Completed'
        })).data
      } catch (e) {
        console.log(e)
      }
    },
    //Patient
    async getRequestedServices ({ }, patientId) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/nursecallingrequests/_filter', {
          patientId: patientId,
          latestStatus: ['Created', 'InProgress']
        })).data

      } catch (e) {
        console.log(e)
      }
    },
    async cancelServiceRequest ({ }, serviceRequestId) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/nursecallingrequests/' + serviceRequestId + '/status', {
          status: 'Cancelled'
        })).data
      } catch (e) {
        console.log(e)
      }
    },
    async requestService ({ }, options) {
      let serviceRequest = {
        service: options.service,
        patientId: options.patientId,
        nursegroup: options.nursegroupId,
        status: [{
          status: 'Created',
          timestamp: new Date().getTime()
        }],
        latestStatus: 'Created'
      }
      try {
        return (await Vue.http.post(this.state.baseUrl + '/nursecallingrequests', serviceRequest)).data
      } catch (e) {
        console.log(e)
      }
    },
  }
}
